// extracted by mini-css-extract-plugin
export var bodyGrid = "globals-module--body-grid--4d9b7";
export var centerAlignedBody = "globals-module--centerAlignedBody--fd693";
export var sectionGrid = "globals-module--sectionGrid--32937";
export var sectionGridAlignCenter = "globals-module--sectionGridAlignCenter--52aae";